var CommonStrata = /*#__PURE__*/function (CommonStrata) {
  CommonStrata["defaults"] = "defaults";
  CommonStrata["underride"] = "underride";
  CommonStrata["definition"] = "definition";
  CommonStrata["override"] = "override";
  CommonStrata["user"] = "user";
  return CommonStrata;
}(CommonStrata || {});
export default CommonStrata;